import type {Combine} from '../../utils/utility-types';
import type {BNUserAccountsMergeParams} from '../types/bnrks/methods';
import type {
  CoreUserAccountsAddParams,
  CoreUserAccountsDeleteParams,
  CoreUserAccountsMakePrimaryParams,
  CoreUserAccountsMergeParams,
  CoreUserAccountsReadParams,
} from '../types/core/methods';
import type {AccountApiModel} from './types';

import {envManager} from '../../utils/env';
import {currentUserStore} from '../user';
import {apiRequest} from '../utils/apiRequest';
import {EntityStore} from '../utils/entityStore';

export class AccountStore<
  T extends AccountApiModel = AccountApiModel,
> extends EntityStore<
  T,
  CoreUserAccountsReadParams,
  CoreUserAccountsAddParams,
  object,
  CoreUserAccountsDeleteParams
> {
  static MERGE_CAPTCHA_ACTION = 'merge';
  makePrimary = this._createMethod<CoreUserAccountsMakePrimaryParams>({
    method: 'user.accounts.make_primary',
  });

  async merge(
    params: Combine<CoreUserAccountsMergeParams, BNUserAccountsMergeParams>,
    captcha: string,
  ) {
    const {account, session, user} = await apiRequest<
      Combine<CoreUserAccountsMergeParams, BNUserAccountsMergeParams>
    >({
      method: 'user.accounts.merge',
      options: {
        captcha,
      },
      params: {
        ...params,
        platform: envManager.get('isB2b') ? undefined : 'web',
      },
    });

    // @ts-expect-error: see auth/store.js constructor
    this.__saveSession(session);

    // @ts-expect-error: see auth/store.js constructor
    await this.__renewAccessToken();

    currentUserStore.setUser(user);
    await currentUserStore.fetch();

    return account;
  }
}

export const accountStore = new AccountStore('account', {
  create: 'user.accounts.add',
  delete: 'user.accounts.delete',
  fetch: 'user.accounts.read',
});
